/**
 * Custom Javascript Code for Gutenberg Blocks.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {

    // Add Helper Classes for Gutenberg

    /* $('.wp-block-columns.alignfull').each(function() {
        var classes = $(this).attr('class').replace('wp-block-columns','').replace('alignfull','');
        //console.log(classes);
        $(this).wrap( '<div class="wp-block-columns__alignfull-container '+classes+'" />');
    }); */

    /* Accordion for Yoast SEO strutctured data block FAQ */

    $('.wp-block-yoast-faq-block').addClass('accordion').attr('data-accordion','').attr('data-multi-expand','true').attr('data-allow-all-closed','true');
    $('.schema-faq-section').addClass('accordion-item').attr('data-accordion-item','');
    $('.schema-faq-question').wrap('<a href="#" class="accordion-title"></a>');
    $('.schema-faq-answer').addClass('accordion-content').attr('data-tab-content','');

    // Add the same +/- circle icon the custom accordion blocks use, so the
    // Yoast FAQ block gets the identical open/close animation (driven by
    // `.accordion-item.is-active .circle-plus` in _block-accordion.scss).
    $('.wp-block-yoast-faq-block .accordion-title').prepend('<div class="circle-plus closed"><div class="circle"><div class="horizontal"></div><div class="vertical"></div></div></div>');

} )( jQuery );
